import styles from "./index.css";
import PropTypes from "prop-types";

const ItemsHeader = ({ children }) => (
  <header className={styles.itemsHeader}>{children}</header>
);

ItemsHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

export default ItemsHeader;
